import React from 'react';
import { Link } from 'react-router-dom';

const ForkAttribution = ({ sheet, className = '' }) => {
  // Don't show anything if this isn't a fork
  if (!sheet?.forked_from) {
    return null;
  }

  return (
    <div className={`text-xs text-gray-500 mb-2 ${className}`}>
      <span className="inline-flex items-center">
        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414L2.586 7a1 1 0 010-1.414l3.707-3.707a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
        Forked from{' '}
        <Link 
          to={`/sheet/${sheet.forked_from}`}
          className="text-blue-600 hover:text-blue-800 underline ml-1"
        >
          original sheet
        </Link>
      </span>
    </div>
  );
};

const ForkCount = ({ count, className = '' }) => {
  if (!count || count === 0) {
    return null;
  }

  return (
    <div className={`text-xs text-gray-500 ${className}`}>
      <span className="inline-flex items-center">
        <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414L2.586 7a1 1 0 010-1.414l3.707-3.707a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
        {count} {count === 1 ? 'fork' : 'forks'}
      </span>
    </div>
  );
};

export { ForkAttribution, ForkCount };
export default ForkAttribution;